export default  () => {
   window.sharedData = {
      stories: {
         lastScrollPosition: null,
         lastUpdateDate: undefined,
      },
   };
};
